import { darken } from '@material-ui/core/styles/colorManipulator'
import times from 'lodash/times'
import styled from 'styled-components'

import theme, { rem } from '../../../utils/theme'

const StyledContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background: ${props =>
    props.noBgGradient
      ? theme.colors.navy
      : `linear-gradient(to bottom,
      ${darken(props.primaryGradient || props.secondaryGradient || theme.colors.navy, 0.1)},
      ${darken(props.secondaryGradient || props.primaryGradient || theme.colors.navy, 0.1)}
    )`};
  padding: ${rem(53)} ${rem(20)};

  .view-mobile & {
    padding: ${rem(30)} 0 0;
  }
`

const StyledInner = styled.div`
  width: 100%;
  max-width: ${rem(406)};
  border-radius: 8px;
  overflow: hidden;

  .view-mobile & {
    border-radius: 0;
  }
`

const StyledStepper = styled.div`
  display: flex;
  width: 100%;
  height: ${rem(33)};
`

const StyledStep = styled.div`
  flex: 1;
  background-color: ${theme.colors.midGrey};
  position: relative;

  &:before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 80%;
    max-width: ${rem(25)};
    min-width: ${rem(18)};
    height: ${rem(5)};
    transform: translate(-50%, -50%);
    border-radius: 2px;
    background-color: ${theme.colors.white};
    transition: ${theme.transitions.smooth};

    .view-mobile & {
      max-width: ${rem(5)};
    }
  }

  &:first-child {
    background-color: ${props => props.navColor || theme.colors.white};
  }
`

const StyledMain = styled.div`
  width: 100%;
  background: ${theme.colors.white};
`

const StyledMainInner = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: ${rem(280)};
  margin: 0 auto;
  padding: ${rem(51)} ${rem(30)};
`

const StyledText = styled.div`
  width: 100%;
  height: ${rem(22)};
  background-color: ${theme.colors.midGrey};
  border-radius: 4px;

  & + & {
    margin-top: ${rem(11)};
  }
`

const StyledButtonWrap = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
`

const StyledButton = styled.div`
  display: inline-flex;
  width: ${rem(80)};
  height: ${rem(24)};
  align-items: center;
  justify-content: center;
  margin-top: ${rem(11)};
  background-color: ${props => props.buttonColor || theme.palette.primary.main};
  border-radius: 4px;
  font-size: ${theme.typography.fontSizeMicro};
  color: ${props => props.buttonTextColor || theme.colors.white};

  .view-mobile & {
    width: 100%;
  }
`

const StyledFooter = styled.div`
  width: 100%;
  height: ${props => (props.viewMobile ? '248px' : '215px')};
  background: ${theme.colors.white};
`

const UpperFooter = styled.div`
  height: ${props => (props.viewMobile ? '178px' : '166px')};
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid ${theme.colors.midGrey};
`

const MobileFooterDivider = styled.div`
  width: 100%;
  height: 18px;
  background-color: ${theme.colors.navy};
`

const UpperFooterContent = styled.div`
  width: ${props => (props.viewMobile ? '250px' : '458px')};
  height: ${props => (props.viewMobile ? '115px' : '68px')};
  margin: auto;
`

const FooterContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 100%;
  gap: 30px;
`

const BigBox = styled.div`
  max-width: 92px;
  height: 68px;
  border-radius: 4px;
  background: ${theme.colors.midGrey};
  flex-grow: 1;
`

const NavItems = styled.div`
  display: flex;
  flex-wrap: wrap;
  height: 100%;
  flex-grow: 1;
`

const LongText = styled.div`
  width: 100%;
  max-width: 92px;
  height: 12px;
  border-radius: 4px;
  background: ${theme.colors.midGrey};
`
const ShortText = styled.div`
  width: 100%;
  max-width: 66px;
  height: 5px;
  border-radius: 4px;
  margin-top: 11px;
  background: ${theme.colors.teal};
`

const ShortTallText = styled.div`
  width: 100%;
  max-width: 66px;
  height: 12px;
  border-radius: 4px;
  margin-top: 8px;
  background: ${theme.colors.midGrey};
`

const MobileBigItemsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: 68px;
`

const MobileBigBox = styled.div`
  width: 100px;
  height: 68px;
  border-radius: 4px;
  background-color: ${theme.colors.midGrey};
`

const MobileMediumBoxContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`

const MobileMediumBox = styled.div`
  width: 120px;
  height: 27px;
  border-radius: 4px;
  background-color: ${theme.colors.midGrey};
`

const MobileSmallItemsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  width: 100%;
  height: 47px;
`

const MobileShortText = styled.div`
  width: 66px;
  height: 12px;
  border-radius: 4px;
  background: ${theme.colors.midGrey};
`

const LowerFooterContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px;
  width: 100%;
  flex-shrink: 1;
`

const SmallSquare = styled.div`
  height: 28px;
  width: 28px;
  border-radius: 4px;
  background: ${theme.colors.teal};
  flex-shrink: 1;
`

const RightHandText = styled.div`
  display: flex;
  gap: 17px;
  flex-shrink: 1;
`

const LowerFooterLongText = styled.div`
  display: flex;
  height: 8px;
  width: ${props => (props.viewMobile ? '104px' : '194px')};
  border-radius: 4px;
  background: ${theme.colors.midGrey}
  flex-shrink: 1;
`

const LowerFooterShortText = styled.div`
  display: flex;
  height: 8px;
  width: 24px;
  border-radius: 4px;
  background: ${theme.colors.teal};
  flex-shrink: 1;
`

const Content = ({
  buttonColor,
  buttonTextColor,
  navColor,
  viewMobile,
  primaryGradient,
  secondaryGradient,
  noBgGradient,
}) => {
  return (
    <>
      <StyledContent
        noBgGradient={noBgGradient}
        primaryGradient={primaryGradient}
        secondaryGradient={secondaryGradient}
      >
        <StyledInner>
          <StyledStepper>
            {times(7, i => (
              <StyledStep key={i} navColor={navColor} />
            ))}
          </StyledStepper>
          <StyledMain>
            <StyledMainInner>
              {times(5, i => (
                <StyledText key={i} />
              ))}
              <StyledButtonWrap>
                <StyledButton buttonColor={buttonColor} buttonTextColor={buttonTextColor} />
              </StyledButtonWrap>
            </StyledMainInner>
          </StyledMain>
        </StyledInner>
      </StyledContent>
      <StyledFooter viewMobile={viewMobile}>
        {viewMobile && <MobileFooterDivider />}
        <UpperFooter viewMobile={viewMobile}>
          <UpperFooterContent viewMobile={viewMobile}>
            {viewMobile ? (
              <>
                <MobileBigItemsContainer>
                  <MobileBigBox />
                  <MobileMediumBoxContainer>
                    <MobileMediumBox />
                    <MobileMediumBox />
                  </MobileMediumBoxContainer>
                </MobileBigItemsContainer>
                <MobileSmallItemsContainer>
                  {times(3, i => (
                    <MobileShortText key={i} />
                  ))}
                </MobileSmallItemsContainer>
              </>
            ) : (
              <FooterContainer>
                <BigBox />
                {times(2, i => (
                  <NavItems key={i}>
                    <LongText />
                    {times(3, j => (
                      <ShortText key={j} />
                    ))}
                  </NavItems>
                ))}
                <NavItems>
                  <LongText />
                  {times(3, i => (
                    <ShortTallText key={i} />
                  ))}
                </NavItems>
              </FooterContainer>
            )}
          </UpperFooterContent>
        </UpperFooter>
        <LowerFooterContent viewMobile={viewMobile}>
          <SmallSquare />
          <RightHandText>
            <LowerFooterLongText />
            <LowerFooterShortText />
          </RightHandText>
        </LowerFooterContent>
      </StyledFooter>
    </>
  )
}

export default Content
